"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARTIFACT_NAME = exports.WIDGET_ID = void 0;
exports.WIDGET_ID = 'CashierCheckoutWidget';
exports.ARTIFACT_NAME = 'cashier-express-checkout-widget';
//# sourceMappingURL=config.js.map